import "../main/header.scss";
import { FaShoppingCart } from "react-icons/fa";
import img from "../../assets/images/Logos/GRC_Logo-removebg-preview.png";
import { NavLink, Link } from "react-router-dom";
import useAuthentication from "hooks/useAuthentication";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext, useState, useEffect } from "react";
import CartModal from "common/order/CartModal";
import Search from "./Search";
import Container from "components/LogIn/Container";
import useWindowSize from "hooks/useWindowSize";
import MenuMobile from "./menuMobile";
import {
  MdOutlineStoreMallDirectory,
  MdOutlineManageAccounts,
} from "react-icons/md";
import {
  IoSearchOutline,
  IoExitOutline,
  IoEnterOutline,
} from "react-icons/io5";
import { RiOrderPlayFill, RiProfileLine } from "react-icons/ri";
import { GoChecklist } from "react-icons/go";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { SiGooglemessages } from "react-icons/si";
import {
  BiHomeSmile,
  BiInfoCircle,
  BiPhoneCall,
  BiMessageSquareAdd,
  BiCategoryAlt,
} from "react-icons/bi";
import {
  MdOutlineSpaceDashboard,
  MdStorefront,
  MdExitToApp,
} from "react-icons/md";
function changeUserInformation(newInfo) {}
const Header = ({ backButtonPressed }) => {
  const { width } = useWindowSize();
  const User = useAuthentication();
  const auth = useContext(WithAuthentication);
  const [isOpen, setIsOpen] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [click, setClick] = useState("");

  useEffect(() => {
    setShowDropDown(false);
    setIsOpen(false);
  }, [backButtonPressed]);
  const [profileLst, setProfileLst] = useState({
    admin: [
      {
        name: "داشبورد",
        icon: <MdOutlineSpaceDashboard className="me-1" />,
        link: "/admin-panel/dashboard",
        type: "link",
        id: 7,
        click: 4,
      },
      {
        name: "سفارشات",
        icon: <RiOrderPlayFill className="me-1" />,
        link: "/admin-panel/orders",
        type: "link",
        id: 8,
        click: 5,
      },
      {
        name: "امور مالی  ",
        icon: <GoChecklist className="me-1" />,
        link: "/admin-panel/financial",
        type: "link",
        id: 14,
        click: 6,
      },
      {
        name: "مدیریت کاربران",
        icon: <MdOutlineManageAccounts className="me-1" />,
        link: "/admin-panel/user_management",
        type: "link",
        id: 9,
        click: 7,
      },
    ],
    shop: [],
    userIsLogin: [
      {
        name: "پروفایل",
        icon: <RiProfileLine className="me-1" />,
        link: "customer-panel/profile",
        type: "link",
        id: 20,
        click: 8,
      },
      {
        name: "سفارشات",
        icon: <RiOrderPlayFill className="me-1" />,
        link: "/customer-panel/orders",
        type: "link",
        id: 21,
        click: 9,
      },
      {
        name: "پیامها",
        icon: <SiGooglemessages className="me-1" />,
        link: "/customer-panel/messages",
        type: "link",
        id: 22,
        click: 10,
      },
    ],
    // userIsNotLogin: [
    //   {
    //     name: "افزودن محصول",
    //     icon: <BiMessageSquareAdd className="me-1" />,
    //     link: "admin-panel/dashboard",
    //     type: "modal",
    //     target: "#addProductModal",
    //     id: 31,
    //   },
    //   {
    //     name: "لیست محصولات",
    //     icon: <RiListSettingsLine className="me-1" />,
    //     link: "admin-panel/products",
    //     type: "link",
    //     id: 32,
    //   },
    // ],
  });
  const links = [
    {
      name: "خانه",
      href: "/",
      id: 1,
      icon: <BiHomeSmile className="me-1" />,
      click: 1,
    },
    {
      name: "فروشگاه  ",
      href: "/store",
      id: 2,
      icon: <MdOutlineStoreMallDirectory className="me-1" />,
      click: 2,
    },

    {
      name: "وبلاگ ",
      href: "/blog",
      id: 3,
      icon: <BiCategoryAlt className="me-1" />,
      click: 3,
    },
  ];
  const [cartItemUpdater, setCartItemUpdater] = useState(false);
  const [expanded, setExpanded] = useState(false);
  // console.log("auth", auth);
  useEffect(() => {
    width > 1000 && setIsOpen(false);
  }, [width]);
  return (
    <>
      {auth.userInfo.userType == 1 && (
        <CartModal cartItemUpdater={cartItemUpdater}></CartModal>
      )}

      <nav
        // onClick={() => setExpanded(expanded ? false : true)}
        className="navbar navbar-style navbar-expand-lg navbar-light bg-light shadow"
      >
        <div className="container-fluid">
          {/* <NavLink
            className="navbar-brand"
            onClick={() => setExpanded(false)}
            to="/"
          ></NavLink> */}
          <NavLink
            className="nav-link"
            onClick={() => setExpanded(false)}
            to="/"
          >
            <img src={img} alt />
          </NavLink>
          <div className="d-flex ">
            {width < 1000 && (
              <div className="mx-3">
                {auth.userInfo.userType == 1 && (
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#CartModal"
                    className="btn position-relative mt-2  ms-3"
                    style={{ boxShadow: "none" }}
                    onClick={() => {
                      setCartItemUpdater((prev) => !prev);
                    }}
                  >
                    <FaShoppingCart className="fa-solid fa-cart-shopping fs-4" />
                  </button>
                )}
              </div>
            )}
            <button
              className="navbar-toggler"
              type="button"
              // data-bs-toggle="collapse"
              // data-bs-target="#navbarNav"
              // aria-controls="navbarNav"
              aria-expanded={expanded ? true : false}
              // aria-expanded="false"
              // aria-label="Toggle navigation"
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <span className="navbar-toggler-icon" />
            </button>
          </div>
          <div
            className={`collapse navbar-collapse ${expanded ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav navbar_links ml-auto ">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/"
                >
                  خانه
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/store"
                >
                  فروشگاه
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/blog"
                >
                  وبلاگ
                </NavLink>
              </li>
            </ul>
            <Search></Search>
            {!auth.isLogged ? (
              <div
                className=" size1 text-decoration-none text-dark  text-center mt-2"
                style={{ cursor: "pointer", marginRight: "auto" }}
                data-bs-toggle="modal"
                data-bs-target="#ModalNumber"
              >
                ورود
              </div>
            ) : (
              <>
                <div
                  className="user-link"
                  style={{
                    // marginRight: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <NavLink
                    to={`${
                      auth.userInfo.userType == 1
                        ? "/customer-panel/orders"
                        : "/admin-panel/orders"
                    }`}
                    className="nav-link "
                  >
                    {auth.userInfo.userType == "1" ? (
                      <>
                        {auth.userInfo.fullName == " "
                          ? " کاربر عزیز  "
                          : auth.userInfo.fullName}
                      </>
                    ) : (
                      "  مدیر "
                    )}
                  </NavLink>
                </div>
                <NavLink to={`/`} className="nav-link ">
                  <div
                    className="user-link exit-button"
                    onClick={auth.logout}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link ">خروج</a>
                  </div>
                </NavLink>
                {width > 1000 && (
                  <div className="text-center">
                    {auth.userInfo.userType == 1 && (
                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#CartModal"
                        className="btn position-relative mt-2  ms-3"
                        style={{ boxShadow: "none" }}
                        onClick={() => {
                          setCartItemUpdater((prev) => !prev);
                        }}
                      >
                        <FaShoppingCart className="fa-solid fa-cart-shopping fs-4" />
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        <Container changeUserInformation={changeUserInformation} />
      </nav>
      <MenuMobile
        click={click}
        setClick={setClick}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        publicLink={links}
        pic={
          auth.userInfo.userType == 1 && auth.userInfo.url
          // : auth.userInfo.userType == 0 &&
          //   auth.userInfo?.bussinesses[0]?.logo_file_record[0]?.url
        }
        privateLink={
          auth.userInfo.userType == 0
            ? profileLst.admin
            : auth.userInfo.userType == 1
            ? profileLst.userIsLogin
            : // : auth.userInfo.userType == -1
              // ? profileLst.userIsNotLogin

              [
                {
                  name: "ورود",
                  icon: <IoEnterOutline className="me-1" />,
                  link: "",
                  type: "modal",
                  target: "#ModalNumber",
                  id: -2,
                },
              ]
        }
      ></MenuMobile>
    </>
  );
};

export default Header;
